<template>
  <div v-loading="isLoading">
    <el-table
      :data="locations"
      stripe
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-row :gutter="10">
            <el-col :md="8">
              <p><strong>Name: </strong>{{ props.row.name || '-' }}</p>
              <p><strong>Address Line 1: </strong>{{ props.row.address_1 || '-' }}</p>
              <p><strong>Address Line 2: </strong>{{ props.row.address_2 || '-' }}</p>
              <p><strong>Suburb: </strong>{{ props.row.suburb || '-' }}</p>
              <p><strong>State: </strong>{{ props.row.state || '-' }}</p>
              <p><strong>Postcode: </strong>{{ props.row.postcode || '-' }}</p>
              <p><strong>Country: </strong>{{ props.row.country || '-' }}</p>
              <p><strong>Residential: </strong>{{ props.row.residential || 'No' }}</p>
            </el-col>
            <el-col :md="8">
              <p><strong>Contact: </strong>{{ props.row.contact || '-' }}</p>
              <p><strong>Phone: </strong>{{ props.row.phone || '-' }}</p>
              <p><strong>Fax: </strong>{{ props.row.fax || '-' }}</p>
              <p><strong>Email: </strong>{{ props.row.email || '-' }}</p>
              <p><strong>Instructions: </strong>{{ props.row.instructions || '-' }}</p>
            </el-col>
            <el-col :md="8">
              <p><strong>Notes: </strong></p>
              <p style="background-Color: #F5F5F5; padding: 5px;">
                {{ props.row.notes || '-' }}
              </p>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column
        label="Name"
        prop="name"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      >
        <template slot-scope="props">
          <span>{{ props.row.name || '-' }}&nbsp;</span>
          <el-tag
            v-if="props.row.is_default_address"
            type="warning"
            size="mini"
          >
            Team
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Address"
        prop="address_1"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      >
        <template slot-scope="props">
          <span>{{ props.row.address_1 || '-' }}</span>
          <span v-if="props.row.address_2">, {{ props.row.address_2 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Suburb"
        prop="suburb"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="State"
        prop="state"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Postcode"
        prop="postcode"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editLocation(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete && !scope.row.is_default_address"
            size="mini"
            type="danger"
            @click.native="deleteLocation(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- Pagination -->
    <br>
    <div style="text-align: center;">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </div>
    <!-- Edit Form -->
    <LocationEditForm
      v-if="isShowEditForm"
      ref="editForm"
      :is-show.sync="isShowEditForm"
      :account-id="accountId"
      :location="location"
      @saved="loadTable"
    />
  </div>
</template>

<script>
import LocationEditForm from '@/components/Application/Manage/Account/LocationEditForm'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
export default {
  components: {
    LocationEditForm
  },
  props: {
    filters: {
      type: Array,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      location: null,
      locations: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: true,
      isShowEditForm: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'account_location')
    },
    canDelete () {
      return this.$user.can(DELETE, 'account_location')
    }
  },
  mounted () {
    this.actions = [
      {
        hidden: this.$user.cannot(CREATE, 'account_location'),
        name: 'Create',
        icon: ['fal', 'plus'],
        event: () => {
          this.location = new this.$sdk.account_location()
          this.isShowEditForm = true
        }
      },
      {
        name: 'Refresh',
        icon: ['fal', 'sync'],
        event: () => this.loadTable()
      }
    ]
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.account_location.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'uuid:asc'
        builder.filters = this.filters
      })
        .then(res => {
          this.locations = res
          this.total = res.total
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    editLocation (index, row) {
      this.location = row.clone()
      this.isShowEditForm = true
    },
    deleteLocation (index, row) {
      this.$confirm('Are you sure to delete this location?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete(builder => {
          builder.context = { resource: 'account', id: this.accountId }
        })
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
